import * as React from 'react';
import * as c from './components';

export default ({ direction, ...rest }) => (
  <c.ArrowContainer direction={direction} {...rest}>
    <c.Arrow direction={direction} />
  </c.ArrowContainer>
);
